import React from 'react';
import PropTypes from 'prop-types';
import FormField from './../FormField';
import RemovableRow from './../RemovableRow';

const ArtistFieldset =  ({ member, index, fields, placeholder, formErrors }) => {
  const onKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      fields.push({});
      e.target.blur();
    }
  };

  return (
    <RemovableRow fields={fields} index={index}>
      <div className="col">
        <FormField
          name={`${member}.name`}
          component="input"
          error={formErrors.getIn(['artists', index.toString(), 'name'])}
          type="text"
          className="form-control"
          placeholder={`Enter ${placeholder}`}
          inputProps={{ onKeyPress }}
        />
      </div>
    </RemovableRow>
  );
};

ArtistFieldset.propTypes = {
  formErrors: PropTypes.object,
  member: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  fields: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
};

export default ArtistFieldset;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/ArtistFieldset.jsx